import { Component, Input } from '@angular/core';

@Component({
  selector: 'components-of-value',
  templateUrl: 'components-of-value.html'
})
export class ComponentsOfValueComponent {
  @Input() componentsOfValue: any = {};
  @Input() currencyUnit: string = 'GBP';

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/components/components-of-value/components-of-value.ts